function isObject(v) {
  return v && typeof v === "object" && !Array.isArray(v);
}

const IMPORTANCE_LABEL = {
  core: "コア",
  supplementary: "補助用",
  administrative: "管理用",
};

function localizeImportance(value) {
  return IMPORTANCE_LABEL[value] || value || "";
}

function extractLeaf(leaf) {
  if (!isObject(leaf)) {
    return { value: leaf ?? "", importance: "", id: "", page: "" };
  }

  // your current structure
  if ("value" in leaf) {
    return {
      value: leaf.value ?? "",
      importance: localizeImportance(leaf.importance),
      id: leaf.id ?? "",
      page: leaf.page ?? "",
    };
  }

  // fallback (JP keys / unknown shape)
  if ("値" in leaf) {
    return {
      value: leaf["値"] ?? "",
      importance: localizeImportance(leaf["重要度"]),
      id: leaf.id ?? "",
      page: leaf.page ?? "",
    };
  }

  return {
    value: JSON.stringify(leaf),
    importance: "",
    id: "",
    page: "",
  };
}

function flatten(node, path = []) {
  const rows = [];

  if (Array.isArray(node)) {
    node.forEach((v, i) => {
      rows.push(...flatten(v, [...path, String(i)]));
    });
    return rows;
  }

  if (!isObject(node)) return rows;

  const looksLikeLeaf =
    "value" in node || "値" in node;

  if (looksLikeLeaf) {
    const leaf = extractLeaf(node);
    // CSV is an extracted-data export, not a schema export. Empty template
    // placeholders and structural metadata must not become dummy rows.
    if (leaf.value !== null && leaf.value !== undefined && String(leaf.value).trim() !== "") {
      rows.push({ path: path.join("/"), ...leaf });
    }
    return rows;
  }

  for (const [k, v] of Object.entries(node)) {
    if (k === "field_id" || k === "key_jp") continue;
    rows.push(...flatten(v, [...path, k]));
  }

  return rows;
}

function toCsv(rows) {
  const headers = ["path", "value", "importance", "id", "page"];
  const esc = (s) => {
    const str = String(s ?? "");
    return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
  };

  return [
    headers.join(","),
    ...rows.map((r) => headers.map((h) => esc(r[h])).join(",")),
  ].join("\n");
}

export function downloadCsvFromJson(json, filename = "ocr_result") {
  const rows = flatten(json);
  const csv = toCsv(rows);

  const BOM = "\uFEFF"; // Excel UTF-8 BOM
  const blob = new Blob([BOM + csv], {
    type: "text/csv;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(url);
}
